<div *ngIf="users" class="mentions-menu">
  <ng-scrollbar style="height: 200px; width: 350px;">
    <ul>
      <li (click)="selectUser($event, user)" *ngFor="let user of users; let i = index"
          [ngClass]="{active: i === activeIndex}"
          class="d-flex align-items-center">
        <sb-avatar [users]="[user]" class="mr-2"></sb-avatar>
        <span class="font-weight-bold">{{user.firstname}} {{user.lastname}}</span>
      </li>
    </ul>
  </ng-scrollbar>
</div>


